// ============================================================================
// TrimaCadranChip — A toggleable competency tag
// ============================================================================

import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLocaleValue } from 'helpers/utils';
import { TrimaCadranItem } from 'pages/questionnaire-trima/types/trima.types';
import { TrimaCadranChipWrapper } from 'pages/questionnaire-trima/slides/cadran/TrimaCadranChip.styled';

export interface TrimaCadranChipProps {
  item: TrimaCadranItem;
  selected: boolean;
  disabled?: boolean;
  onToggle: (itemId: number) => void;
}

const TrimaCadranChip: React.FC<TrimaCadranChipProps> = ({ item, selected, disabled, onToggle }) => {
  const { i18n } = useTranslation();
  return (
    <TrimaCadranChipWrapper
      type="button"
      $selected={selected}
      $disabled={disabled}
      aria-pressed={selected}
      aria-disabled={disabled}
      onClick={() => !disabled && onToggle(item.id)}
    >
      {getLocaleValue(item.label, i18n.language)}
    </TrimaCadranChipWrapper>
  );
};

export default TrimaCadranChip;
